const softballData = [
    //Workspace: Softball Data Delivery
    {
        "category": "app",
        "type": 'internal',
        "name": "Data Delivery",
        "keyUsers": "R&D",
        "access": "All Staff",
        "keyUseCases": "<ul><li> Delivery Overview</li></ul>",
        "dataSummary": "<ul><li>History: 3 days Rolling</li><li>Updates Daily: Automatic</li></ul>",
        "reports": [
            {
                reportId: 'da5f4449-c845-4f45-9704-36b503929c86',
                applicationId: '81329b4b-286e-4186-b41f-52d2a32ae16c',
                name: "Softball Data Delivery",
                visible: false
            }
        ]
    }
]


// ****************** UPDATE ALL THE OBJECTS WITH APP URL AND SPORT ****************** //
function createUrlFromName(name) {
    let url = name.toLowerCase();
    url = url.replace(/[^\w\s-]/g, '-');
    url = url.replace(/[\s-]+/g, '-');
    return url;
}

function updateAppIds(objects) {
    objects.forEach(obj => {
        const urlFromName = createUrlFromName(obj.name);
        const sport = 'softball';
        obj.appId = urlFromName;
        obj.sport = sport;
        obj.reports = obj.reports.map(item => ({...item, appId: urlFromName, sport: sport}));
    });
}

updateAppIds(softballData);
export {softballData};